import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Modal, Field, SaButton, sa, errMsg } from './ui';

export const ChangePasswordModal = ({ onClose }) => {
  const [f, setF] = useState({ current: '', next: '', confirm: '' });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 12) return toast.error('Use at least 12 characters');
    if (f.next !== f.confirm) return toast.error('New passwords do not match');
    setBusy(true);
    try {
      const { data } = await axios.put('/auth/change-password', { current_password: f.current, new_password: f.next });
      if (data.token) {
        localStorage.setItem('token', data.token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
      }
      toast.success('Super Admin password updated — other sessions were signed out');
      onClose();
    } catch (err) {
      toast.error(errMsg(err, 'Could not change password'));
      setBusy(false);
    }
  };

  return (
    <Modal title="Change Super Admin password" onClose={onClose} testId="sa-change-password-modal">
      <p style={{ color: '#A1A1AA', fontSize: 13, marginTop: 0, marginBottom: 16, lineHeight: 1.5 }}>
        Applies to this environment only. The SUPERADMIN_PASSWORD env value is just the first-run seed and does not overwrite this.
      </p>
      <form onSubmit={submit}>
        <Field label="Current password"><input data-testid="sa-pw-current" type="password" autoComplete="current-password" style={sa.input} value={f.current} onChange={set('current')} required /></Field>
        <Field label="New password (min 12 characters)"><input data-testid="sa-pw-new" type="password" autoComplete="new-password" style={sa.input} value={f.next} onChange={set('next')} required /></Field>
        <Field label="Confirm new password"><input data-testid="sa-pw-confirm" type="password" autoComplete="new-password" style={sa.input} value={f.confirm} onChange={set('confirm')} required /></Field>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 8 }}>
          <SaButton type="button" variant="ghost" onClick={onClose}>Cancel</SaButton>
          <SaButton type="submit" data-testid="sa-pw-submit" disabled={busy}>{busy ? 'Saving…' : 'Update password'}</SaButton>
        </div>
      </form>
    </Modal>
  );
};
